module.exports = __webpack_public_path__ + "static/ACaslonPro-Italic-1e8109f409179c88f39105e9abd627cd.woff";